// Per-filter "N excluded" — sits at the right of a filter header, next to the
// view toggle, and counts SECURITIES dropped by that filter (not categories).
//
// It belongs to the filter, not to a view: the exclusions are the same set
// whether you are looking at the simple pills or the advanced panel, so the
// badge renders in BOTH headers. It used to be inlined in the simple header
// only, which made the count vanish the moment you opened Advanced View —
// exactly when you are doing the most excluding.
// The number is a LIVE estimate: it counts what the exclusion removes from the
// CURRENT snapshot, not over the backtest's range. Excluding something the
// universe holds nothing for today reads 0 and is still a real exclusion — the
// green dot on the row is what distinguishes the two.
export function FilterExcludedCountBadge({ count }: { count: number }) {
  if (count <= 0) return null;
  return (
    <span className="text-xs px-2 py-0.5 rounded-md border border-destructive/20 bg-destructive/5 text-destructive/80 font-medium shrink-0">
      {count.toLocaleString()} excluded
    </span>
  );
}
